<template>
  <div>
    <p class="title-page">Unidades Consumidoras</p>
    <TableUnidadesConsumidoras />
  </div>
</template>

<script>
import TableUnidadesConsumidoras from "../components/TableUnidadesConsumidoras.vue";

export default {
  name: "UnidadesConsumidoras",

  components: {
    TableUnidadesConsumidoras,
  },
};
</script>
